module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"about_artist":"关于艺术家","work":"名称","client":"客户","artist":"艺术家","view_more_themes":"查看更多主题"},"en":{"about_artist":"About Artist","work":"Work","client":"Client","artist":"Artist","view_more_themes":"View more themes"}}')
  delete Component.options._Ctor
}
